export default __webpack_public_path__ + "static/media/frontdoor.ab413d58.jpg";